import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbComponent} from "./breadcrumb/breadcrumb.component";
import {RouterModule} from "@angular/router";
import {TopControlComponent} from "./top-control/top-control.component";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {PvFormComponent} from "./pv-form/pv-form.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {
   DxButtonModule,
   DxDataGridModule,
   DxFileUploaderModule, DxGalleryModule,
   DxPopupModule,
   DxScrollViewModule
} from "devextreme-angular";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MaterialFileInputModule} from "ngx-material-file-input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTableModule} from "@angular/material/table";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {TabTaglieComponent} from "./tab-taglie/tab-taglie.component";
import {TabImmaginiComponent} from "./tab-immagini/tab-immagini.component";
import {FormAssistenzaComponent} from "./form-assistenza/form-assistenza.component";
import {ClienteFormComponent} from "./cliente-form/cliente-form.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatTabsModule} from "@angular/material/tabs";
import {AutocompleteMultiselectComponent} from "./autocomplete-multiselect/autocomplete-multiselect.component";
import {MatChipsModule} from "@angular/material/chips";
import {BarcodeInputComponent} from "./barcode-input/barcode-input.component";
import {PrintEtichetteComponent} from "./print-etichette/print-etichette.component";
import {TabCategoryCompositionComponent} from "./tab-category-composition/tab-category-composition.component";
import {ConvalidaRicezioneComponent} from "./convalida-ricezione/convalida-ricezione.component";
import {MatCardModule} from "@angular/material/card";
import {MatSliderModule} from "@angular/material/slider";
import {
   PvOrdineForConvalidaComponent
} from "../../pages/root/esercizio/pvendita/pv-ordini-fornitori/pv-ordine-for-convalida/pv-ordine-for-convalida.component";
import {MatNativeDateModule} from "@angular/material/core";
import {SidenavComponent} from "../sidenav/sidenav.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatBadgeModule} from "@angular/material/badge";
import {MatDialogModule} from "@angular/material/dialog";
import {MatListModule} from "@angular/material/list";
import {MatSidenavModule} from "@angular/material/sidenav";
import {HeaderTopModule} from "../standalone/header-top/header-top.module";
import {SnackComponent} from "./snack/snack.component";
import {DialogWrapperComponent} from "./dialog/dialog-wrapper/dialog-wrapper.component";
import {AutocompleteInputModule} from "../standalone/autocomplete-input/autocomplete-input.module";
import {DialogComponentsModule} from "../dialogs/dialog-components.module";
import {AlertModule} from "../standalone/alert/alert.module";
import {DebounceClickDirective} from "../directives/debounce-click.directive";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import { AmministratoreFormComponent } from './amministratore-form/amministratore-form.component';
import {MatRadioModule} from "@angular/material/radio";
import {EsercizioUserFormComponent} from "./esercizio-user-form/esercizio-user-form.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {ShortNamePipe} from "../short-name.pipe";
import {SkeletonComponent} from "./skeleton/skeleton.component";
import { TabStoricoAssortimentiComponent } from './tab-storico-assortimenti/tab-storico-assortimenti.component';
import { PvInstancesComponent } from './pv-instances/pv-instances.component';
import { PopupBarcodeComponent } from './popup-barcode/popup-barcode.component';
import { TabellaRiepilogoOrdineComponent } from './tabella-riepilogo-ordine/tabella-riepilogo-ordine.component';
import { TabTrasferimentiComponent } from './tab-trasferimenti/tab-trasferimenti.component';
import {ImageZoomComponent} from "./image-zoom/image-zoom.component";
import { TabellaRettificheComponent } from './tabella-rettifiche/tabella-rettifiche.component';
import { TabellaVariantiComponent } from './tabella-varianti/tabella-varianti.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {TemplateVariantsComponent} from "./template-variants/template-variants.component";
import {ModalUploadFileComponent} from "./modal-upload-file/modal-upload-file.component";


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatSelectModule,
        MatInputModule,
        DxFileUploaderModule,
        NgxMatSelectSearchModule,
        MaterialFileInputModule,
        MatTooltipModule,
        DxPopupModule,
        DxDataGridModule,
        DxButtonModule,
        MatTableModule,
        MatButtonToggleModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatChipsModule,
        MatCardModule,
        MatSliderModule,
        FormsModule,
        MatNativeDateModule,
        DxScrollViewModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatBadgeModule,
        MatDialogModule,
        HeaderTopModule,
        AutocompleteInputModule,
        DialogComponentsModule,
        AlertModule,
        MatRadioModule,
        MatToolbarModule,
        DxGalleryModule,
        MatGridListModule,
        ModalUploadFileComponent,

    ],
   declarations: [
      BreadcrumbComponent,
      PvFormComponent,
      TabTaglieComponent,
      TabImmaginiComponent,
      FormAssistenzaComponent,
      ClienteFormComponent,
      AutocompleteMultiselectComponent,
      BarcodeInputComponent,
      PrintEtichetteComponent,
      TopControlComponent,
      TabCategoryCompositionComponent,
      ConvalidaRicezioneComponent,
      PvOrdineForConvalidaComponent,
      SidenavComponent,
      SnackComponent,
      DialogWrapperComponent,
      DebounceClickDirective,
      ChangePasswordComponent,
      AmministratoreFormComponent,
      EsercizioUserFormComponent,
      ShortNamePipe,
      SkeletonComponent,
      TabStoricoAssortimentiComponent,
      PvInstancesComponent,
      PopupBarcodeComponent,
      TabellaRiepilogoOrdineComponent,
      TabTrasferimentiComponent,
      ImageZoomComponent,
      TabellaRettificheComponent,
      TabellaVariantiComponent,
      TemplateVariantsComponent
   ],
   exports: [
      BreadcrumbComponent,
      PvFormComponent,
      TabTaglieComponent,
      TabImmaginiComponent,
      FormAssistenzaComponent,
      ClienteFormComponent,
      AutocompleteMultiselectComponent,
      BarcodeInputComponent,
      PrintEtichetteComponent,
      TopControlComponent,
      TabCategoryCompositionComponent,
      ConvalidaRicezioneComponent,
      PvOrdineForConvalidaComponent,
      TabCategoryCompositionComponent,
      SidenavComponent,
      SnackComponent,
      DialogWrapperComponent,
      DebounceClickDirective,
      ChangePasswordComponent,
      AmministratoreFormComponent,
      EsercizioUserFormComponent,
      ShortNamePipe,
      SkeletonComponent,
      TabStoricoAssortimentiComponent,
      PvInstancesComponent,
      PopupBarcodeComponent,
      TabellaRiepilogoOrdineComponent,
      TabTrasferimentiComponent,
      ImageZoomComponent,
      TabellaRettificheComponent,
      TabellaVariantiComponent,
      TemplateVariantsComponent

   ],
   providers: [
      MatDatepickerModule,
   ]
})
export class GenericsModule { }

